module.exports = "<svg viewBox=\"0 0 11.1 16.9\"><path fill=\"#231F20\" d=\"M4.8 16.9c-.8 0-1.5-.7-1.5-1.5V4.8c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v10.5c0 .9-.6 1.6-1.5 1.6z\"></path><path fill=\"#231F20\" d=\"M8.2 10.1H1.5C.7 10.1 0 9.4 0 8.6s.7-1.5 1.5-1.5h6.7c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM4.8 6.3c-.8 0-1.5-.6-1.5-1.5C3.3 2.2 5.5 0 8.2 0h1.4c.8 0 1.5.7 1.5 1.5S10.4 3 9.6 3H8.2c-1 0-1.8.8-1.8 1.8-.1.9-.7 1.5-1.6 1.5z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/fat-facebook.svg
// module id = 298
// module chunks = 1